/**
 * Breadcrumbs for AREA-EVENTS detail routes. Each reads the cached detail
 * query (the page loads it anyway) and falls back to the raw ID.
 */
import { useQuery } from '@tanstack/react-query'
import { IdCrumb } from '@/shell/crumbs'
import { eventTypeQuery, messageQuery } from './api'

export function EventTypeCrumb({ params }: { params: Record<string, string> }) {
  const id = params.eventTypeId ?? ''
  const q = useQuery({ ...eventTypeQuery(id), enabled: !!id })
  return q.data ? <span className="font-mono text-xs">{q.data.key}</span> : <IdCrumb value={id} />
}

export function MessageCrumb({ params }: { params: Record<string, string> }) {
  const id = params.messageId ?? ''
  const q = useQuery({ ...messageQuery(id), enabled: !!id })
  const subject = q.data?.subject
  return subject ? (
    <span className="inline-block max-w-[32ch] truncate align-bottom">{subject}</span>
  ) : (
    <IdCrumb value={id} />
  )
}
